import { render } from "./DataPenghasilan.vue?vue&type=template&id=7c38654a"
import script from "./DataPenghasilan.vue?vue&type=script&lang=js"
export * from "./DataPenghasilan.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__